import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'

export type InputProps = {
}

export type Variables = {
  logo?: File
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

const COMPANY_LOGO_MUTATION = gql`
  mutation setCompanyLogo($logo: Upload!) {
    setCompanyLogo(logo: $logo)
  }
`

const withCompanyLogoMutation = graphql<InputProps, Response, Variables, ChildProps>(
  COMPANY_LOGO_MUTATION,
)

export default withCompanyLogoMutation
